module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-766913e6.ttf";